// Centralized client environment config
const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

// Relative in production, so calls go through the host's /api proxy
// (netlify.toml / vercel.json) and land on this same origin.
//
// Calling the API host directly makes the session cookie third-party for any
// frontend not on misbahi.in — browsers block those, so the cookie is never
// stored and every authenticated request 401s. Going through the proxy keeps it
// first-party on every deployment, and sidesteps CORS entirely.
//
// Set REACT_APP_API_URL to an absolute URL only if you intentionally want to
// bypass the proxy (and accept the cookie consequences).
export const API_BASE_URL = process.env.REACT_APP_API_URL
  || (isLocalhost ? 'http://localhost:8080/api' : '/api');

export const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '');
